export const FILTER_TYPES = {
  VILLA_TYPE: 'villaType',
  MINMAX: 'minMax',
  EXACT: 'exact',
  EXACT_FIELD: 'exactField',
};
